import { render, staticRenderFns } from "./OrderExpired.vue?vue&type=template&id=73c61bb0&scoped=true"
import script from "./OrderExpired.vue?vue&type=script&lang=js"
export * from "./OrderExpired.vue?vue&type=script&lang=js"
import style0 from "./OrderExpired.vue?vue&type=style&index=0&id=73c61bb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c61bb0",
  null
  
)

export default component.exports